module.exports = __webpack_public_path__ + "img/手淘推荐-其它猜你喜欢示例图.7abb20ff.jpeg";